export enum StockLevel {
  IN_STOCK,
  PARTIAL_STOCK,
  NOT_IN_STOCK,
}
